import React from 'react';
import { Helmet } from 'react-helmet';

import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Section from '@zg-rentals/multibrand-ui/lib/Section';

const PropertyReviewGuidelinesPage = () => {
  return (
    <div className="PropertyReviewGuidelinesPage">
      <Helmet>
        <title>Property Review Guidelines</title>
      </Helmet>
      <Container>
        <Section>
          <Text type="h1" className="stacked-lg">
            Property Review Guidelines
          </Text>
          <Text type="body" className="stacked-md">
            We welcome and encourage you to participate in the Zillow Group Property Review survey. By submitting a
            property review, you agree to abide by these Guidelines as modified from time to time, as well as Zillow
            Group&apos;s Good Neighbor Policy.
          </Text>
          <Text type="body" className="stacked-md">
            Be helpful! Our property reviews are intended to provide helpful, relevant property specific insights for
            people who are searching for their next home to rent. The content in your review should be relevant to the
            property you are reviewing, based on your own honest opinions and experiences and written in your original
            words.
          </Text>
          <Text type="body" className="stacked-md">
            We value diverse opinions; while you may not agree with a review someone has posted about a property, it may
            be helpful for someone else. Please be respectful of others and do not submit reviews that include any of
            the following:
          </Text>
          <Text type="body" className="stacked-md">
            <ul>
              <li>
                - Language that is foul, profane, vulgar, obscene, threatening, sexual or inappropriate, or that
                endorses or promotes illegal or hateful activity
              </li>
              <li>
                - Personal attacks and/or patently offensive or discriminatory, libelous, defamatory, harassing,
                threatening or inflammatory comments or hate speech
              </li>
              <li>
                - Comments that indicate a preference for or against residents in the neighborhood or at the property
                based on race, color, ethnic or national origin, religion, sexual orientation, age or marital, familial
                status or any other protected class
              </li>
              <li>
                - Information that is not relevant within the context of the website or to the property you are
                reviewing
              </li>
              <li>- Advertising, promotions or commercial content, logos, links or company names</li>
              <li>- Content that does not represent your personal experience</li>
              <li>
                - Content that otherwise violates any law, rule or regulation, including fradulent content, phishing, or
                spam
              </li>
            </ul>
          </Text>
          <Text type="body" className="stacked-md">
            We reserve the right not to post any submission that we feel does not comply with our Guidelines or
            policies, or is generally inappropriate, off-topic or lacks an appropriate level of detail. If you violate
            our Guidelines, we further reserve the right to restrict your ability to submit future reviews, remove
            content and suspend or disable your account. The opinions expressed in these reviews are those of users and
            not of Zillow Group, Inc.. We do not endorse any of the opinions expressed and reserve the right to remove
            or edit a review at any time for any reason.
          </Text>
        </Section>
      </Container>
    </div>
  );
};

export default PropertyReviewGuidelinesPage;
